var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-yoga-layout",
    {
      staticClass: "clickable",
      attrs: {
        "width-auto": "1",
        "height-auto": "1",
        "flex-direction": "row",
        "align-items": "flex-start",
        "justify-content": "flex-start",
        padding: "0.1",
        geometry: "primitive: rounded-plane;",
        material: "color: #001034",
        "push-mesh-backwards": "distance: 0.05",
      },
    },
    [
      _c("a-image", {
        staticClass: "clickable",
        attrs: {
          src: "/aframe-assets/icons/cancel-padded.png",
          width: "0.1",
          height: "0.1",
          "yoga-layout-item": "position: absolute; right:0.02; top:0.02",
          "ui-icon": "",
          "hide-modal": "#modal-" + _vm.infospot.id,
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.infospot.children, function (block) {
        return [
          block.block_type === "intro"
            ? _c("intro", { attrs: { block: block } })
            : _vm._e(),
          _vm._v(" "),
          block.block_type === "quote"
            ? _c("quote", { attrs: { block: block } })
            : _vm._e(),
          _vm._v(" "),
          block.block_type === "image"
            ? _c("image-text", { attrs: { block: block } })
            : _vm._e(),
          _vm._v(" "),
          block.block_type === "imageAlone"
            ? _c("image-alone", { attrs: { block: block } })
            : _vm._e(),
          _vm._v(" "),
          block.block_type === "video"
            ? _c("video-block", { attrs: { block: block } })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }